module.exports = __webpack_public_path__ + "img/ob+_logo_nav.ac17c287.svg";